import CoolIcon from "../assets/icons/cool.svg";
import HeatIcon from "../assets/icons/heat.svg";
import DryIcon from "../assets/icons/dry.svg";
import HeatAndCoolIcon from "../assets/icons/heat_and_cool.svg";
import FanOnlyIcon from "../assets/icons/fan_only.svg";
import BoostIcon from "../assets/icons/boost.svg";

export const OP_MODE = {
    "HEAT": "HEAT",
    "COOL": "COOL",
    "HEAT_AND_COOL": "HEAT_AND_COOL",
    "DRY": "DRY",
    "FAN_ONLY": "FAN_ONLY"
}

export const WEATHER_WIDGET_PROVIDERS = {
    "WEATHER_WIDGET_DOT_ORG": "WEATHER_WIDGET_DOT_ORG",
    "OPEN_WEATHER_MAP": "OPEN_WEATHER_MAP",
};

export const CONNECTION_TYPE = {
    "WIFI": "WIFI",
    "LTE": "LTE",
};

export const CONNECTION_TYPE_DISPLAY_VALUES = {
    [CONNECTION_TYPE.WIFI]: "Wi-Fi",
    [CONNECTION_TYPE.LTE]: "LTE",
};

export const CURRENT_LIMIT_DISPLAY_VALUES = {
        SEVEN_POINT_FIVE_AMP: "7.5 Amps",
        TWELVE_AMP: "12 Amps",
};

export const OP_MODE_DISPLAY_VALUES = {
    [OP_MODE.HEAT]: "Heat",
    [OP_MODE.COOL]: "Cool",
    [OP_MODE.HEAT_AND_COOL]: "Heat and Cool",
    [OP_MODE.DRY]: "Dry",
    [OP_MODE.FAN_ONLY]: "Fan Only",
};

export const CONTROL_SOURCE = {
    "NEXUS": "Nexus",
    "USER": "User",
    "NOT_APPLIED": "Not Applied",
};

export const DEFAULT_CONTROL_VALUES = {
    "HEAT_LOWER_LIMIT_F": 55,
    "COOL_UPPER_LIMIT_F": 90,
    "DEAD_BAND_F": 5,
}

export const MODE_OPTIONS = [
  { id: 1, label: "DRY", value: "DRY", icon: DryIcon },
  { id: 2, label: "COOL", value: "COOL", icon: CoolIcon },
  { id: 3, label: "HEAT AND COOL", value: "HEAT_AND_COOL", icon: HeatAndCoolIcon },
  { id: 4, label: "HEAT", value: "HEAT", icon: HeatIcon },
  { id: 5, label: "FAN ONLY", value: "FAN_ONLY", icon: FanOnlyIcon },
];

export const FAN_SETTING_OPTIONS = [
  { id: 1, label: "LOW", value: "LOW", number: "1" },
  { id: 2, label: "MEDIUM", value: "MEDIUM", number: "2" },
  { id: 3, label: "HIGH", value: "HIGH", number: "3" },
  { id: 4, label: "BOOST", value: "BOOST", icon: BoostIcon },
  { id: 5, label: "AUTO", value: "AUTO", number: "A" },
  { id: 6, label: "SILENT", value: "SILENT", number: "S" },
];

export const HEAT_COLOR = "#fe5b26";
export const COOL_COLOR = "#0099ff";
export const OFF_COLOR = "#FFA526";
// Fills the schedule fan-speed stepper's pill, matching the mobile app's near-black
// treatment. Same hex as the app's existing "dark-grey" Tailwind token.
export const FAN_SPEED_COLOR = "#1E2A2C";

// Colored text values for the schedule feature's mode dropdown/list, mirroring the
// mobile app's color-coded mode names. Kept separate from MODE_OPTIONS/FAN_SETTING_OPTIONS
// so the existing Zone Override Control pie menu (which uses those) is unaffected.
export const SCHEDULE_MODE_OPTIONS = [
  { id: 1, label: "DRY", value: "DRY", color: COOL_COLOR },
  { id: 2, label: "COOL", value: "COOL", color: COOL_COLOR },
  { id: 3, label: "HEAT AND COOL", value: "HEAT_AND_COOL", color: [HEAT_COLOR, COOL_COLOR] },
  { id: 4, label: "HEAT", value: "HEAT", color: HEAT_COLOR },
  { id: 5, label: "FAN ONLY", value: "FAN_ONLY", color: COOL_COLOR },
  { id: 6, label: "OFF", value: "OFF", color: OFF_COLOR },
];

// Ordered low-to-high progression for the schedule feature's fan-speed stepper. Kept
// separate from FAN_SETTING_OPTIONS' order since that order drives the existing pie menu.
export const SCHEDULE_FAN_STEP_ORDER = ["AUTO", "SILENT", "LOW", "MEDIUM", "HIGH", "BOOST"];

export const ALERT_VIDEOS = {
  AIR_FILTER_VIDEO_URL: "https://www.youtube.com/watch?v=dRifDZDM54U",
  CONDENSATE_VIDEO_URL: "https://www.youtube.com/watch?v=5rKj0ANV8Rk",
};
